
import { supabase } from "@/integrations/supabase/client";

export const fetchProgramCount = async () => {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    if (user) {
      const { data: programsData, error } = await supabase
        .from('programs')
        .select('program_id')
        .eq('coach_id', user.id);
      
      if (!error && programsData) {
        console.log('Fetched program count:', programsData.length);
        return programsData.length;
      }
    }
  } catch (error) {
    console.error('Error fetching program count:', error);
  }
  return 0;
};
